module.exports = __webpack_public_path__ + "static/img/学科资源.cd7bd451.png";